import type { FunctionComponent } from 'react';
import { useCallback } from 'react';

import {
    getFeatureConfig,
    parseFeatureConfigFromStorage,
    saveFeatureConfigToStorage,
} from '@luna/feature-config';
import type { SharedFeatureConfig } from '@shared/feature-config';

import { DevToolsToggle } from '../DevToolsToggle';

function setProxyVersion(version: 'v1' | 'v2'): void {
    const storedFeatureConfig = parseFeatureConfigFromStorage() as SharedFeatureConfig;
    storedFeatureConfig.alexProxyVersion = version;
    saveFeatureConfigToStorage(storedFeatureConfig);
}

export const ProxyVersionToggle: FunctionComponent = () => {
    const { alexProxyVersion } = getFeatureConfig((config) => config);

    const handleToggle = useCallback((isActive: boolean) => {
        if (isActive) {
            setProxyVersion('v2');
        } else {
            setProxyVersion('v1');
        }
        window.location.reload();
    }, []);

    return (
        <DevToolsToggle
            active={alexProxyVersion === 'v2'}
            label="Use proxy v2"
            onToggle={handleToggle}
        />
    );
};
